import React from 'react';
import { connect } from 'react-redux';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import ForwarderComponent from './components/ForwarderComponent';
import DriverComponent from './components/DriverComponent';
import DelivererTypeComponent from './components/DelivererTypeComponent';

import ForwarderModel from '../../../../models/ForwarderAwb';
import DriverInfoModel from '../../../../models/GhaManualEntryDriverInfo';
import StationsModel from '../../../../models/Stations';
import GhaDock from '../../../../models/GhaDock';

import style from './manualEntryStyle.module.css';
import AirlineType from '../../../../models/AirlineType';
import ManualEntryAdd from '../../../../models/ManualEntryAdd';
import User from '../../../../models/User';

const styles = (theme: Theme) =>

  createStyles({
    submitBtn: {
      margin: '10px 16px',
      fontSize: '13px',
    },
    close: {
      fontSize: '27px',
      color: '#fff',
      padding: '0px',
    },
    dialogContent: {
      paddingTop: '24px',
    },
    '@media (max-width:480px)': {
      dialogPaper: {
        margin: '0px',
        width: '90%'
      },
    },
  });

interface ManualEntryModalProps {
  classes: any;
  modalOpen: boolean;
  handleCloseModal: (isUpdated?: boolean, edit?: boolean, cancel?: boolean) => void;
  forwarderName: string;
  forwarders: Array<ForwarderModel>;
  forwarderValue: number | undefined;
  forwarderLocationValue: number| undefined;
  isCreateFwd: boolean;
  handleOpenCreateFwd: () => void;
  handleCreateForwarder: () => void;
  driverInfo: DriverInfoModel;
  selectedDock: number | null;
  docks: Array<GhaDock>;
  handleChange: (type: string, event: any) => void;
  handleSubmit: () => void;
  errors: DriverInfoModel;
  forwarderError: string;
  onClick: (event: any) => void;
  maskon:() => void;
  forwarderNameError: string;
  delivererType: string;
  handleChangeDelivererType: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isEditMode: boolean;
  handleUpdateDriverInfo?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type: string;
  stations: Array<StationsModel>;
  stationValue: string;
  cityCodes: Array<StationsModel>;
  handleCancelCreateFwd: () => void;
  cityCodeValue: string;
  cityCodeError: string;
  openModalRecheckFwd: boolean;
  handleCloseFwdModal: () => void;
  relevantForwarders: Array<ForwarderModel>;
  selectedForwarder: string;
  selectedForwarderLocationValue: string;
  handleSelectForwarder: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleAddSelForwarder: () => void; 
  handleAddNewFwd: () => void;
  airlines: AirlineType[];
  isAddMode: ManualEntryAdd;
  user: User;
};

const manualEntryModal = (props: ManualEntryModalProps) => {

  const { classes } = props;
  const titleText: string = props.isEditMode ? 'Update' : 'Capture';
  const typeText: string = props.type === 'po' ? 'Pick Up' : props.type === 'go' ? 'GO Pick up' : 'Drop Off';
  const orderTypeText: string = props.type === 'po' ? 'Import' : 'Export';
  const disabled: boolean = props.isAddMode ? true : false;
  const buttonText: string = props.isEditMode ? 'Edit Manual Entry' : props.isAddMode ? 'Add Awbs to order' : 'Manual Entry';

  const isManagerOrSupervisor = props.user.roleName === 'GHA Manager' || props.user.roleName === 'GHA Supervisor';
  const shouldDisableEdit = props.isEditMode && !isManagerOrSupervisor;

  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ () => props.handleCloseModal(false, false, true) }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'lg' }
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: props.classes.dialogPaper }}
    >
    <DialogTitle id="form-dialog-title" className={ style.dialogTitleRoot }>
      <div className={ style.dialogTitle }>
        <span>{ titleText } { typeText } Details { props.type !== 'go' && `(${orderTypeText})` }</span>
        <IconButton aria-label="Close" onClick={ () => props.handleCloseModal(false, false, true) } className={ classes.close } disableRipple>
          <CloseIcon fontSize='inherit'/>
        </IconButton>
      </div>
    </DialogTitle>
    <DialogContent className={ classes.dialogContent }>
      <DelivererTypeComponent 
        delivererType={ props.delivererType }
        handleChangeDelivererType={ props.handleChangeDelivererType }
        type={ props.type }
      />

      {props.type !== 'go' && <ForwarderComponent
        forwarderName={props.forwarderName }
        forwarders={ props.forwarders }
        forwarderValue={ props.forwarderValue }
        forwarderLocationValue={ props.forwarderLocationValue }
        isCreateFwd={ props.isCreateFwd }
        handleOpenCreateFwd={ props.handleOpenCreateFwd }
        handleChange={ props.handleChange}
        handleCreateForwarder={ props.handleCreateForwarder }
        forwarderError={ props.forwarderError }
        onClick={ props.onClick }
        forwarderNameError={ props.forwarderNameError }
        delivererType={ props.delivererType }
        stations={ props.stations }
        stationValue={ props.stationValue }
        cityCodes={ props.cityCodes }
        handleCancelCreateFwd={ props.handleCancelCreateFwd }
        cityCodeValue={ props.cityCodeValue }
        cityCodeError={ props.cityCodeError }
        openModalRecheckFwd={ props.openModalRecheckFwd }
        handleCloseFwdModal={ props.handleCloseFwdModal }
        relevantForwarders={ props.relevantForwarders }
        selectedForwarder={ props.selectedForwarder }
        selectedForwarderLocationValue={ props.selectedForwarderLocationValue }
        handleSelectForwarder={ props.handleSelectForwarder }
        handleAddSelForwarder= { props.handleAddSelForwarder }
        handleAddNewFwd={ props.handleAddNewFwd }
        airlines={ props.airlines }
        airlineValue={ props.driverInfo.interlineTransfer }
      />}

      <DriverComponent 
        driverInfo={ props.driverInfo }
        selectedDock={ props.selectedDock }
        docks={ props.docks }
        handleChange={ props.handleChange }
        errors={ props.errors }
        onClick={ props.onClick }
        maskon={props.maskon }
        delivererType={ props.delivererType }
        disabled={ disabled }
      />
    </DialogContent>
    <DialogActions>
      { props.isEditMode &&
        <Button 
          className={ classes.submitBtn }
          variant="contained" 
          color="primary" 
          onClick={ props.handleUpdateDriverInfo }
          >
          Update and Exit
        </Button>
      }
      <Button 
        className={ classes.submitBtn }
        variant="contained" 
        color="primary" 
        onClick={ props.handleSubmit }
        disabled={shouldDisableEdit}
      >
        { buttonText }
      </Button>
    </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state: any) => {
  return {
    isEditMode: state.manualEntryEdit.isEditMode,
    isAddMode: state.manualEntryAdd.isAddMode,
    user: state.user
  }
}

export default withStyles(styles)(connect(mapStateToProps, {})(manualEntryModal));
